// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"348":"base","535":"login"}[chunkId] + "." + {"348":"86d6aafd","535":"f7a0289d"}[chunkId] + ".js";
};